import React, { useState, useEffect } from 'react';

export const TypewriterText = ({ text, onComplete, onPartialUpdate, speed = 30 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  const words = text?.split(' ');

  useEffect(() => {
    if (currentIndex < words?.length) {
      const timer = setTimeout(() => {
        const newText = currentIndex === 0 
          ? words[currentIndex] 
          : displayedText + ' ' + words[currentIndex];
        setDisplayedText(newText);
        setCurrentIndex(prev => prev + 1);
        if (onPartialUpdate) {
          onPartialUpdate(newText);
        }
      }, speed);

      return () => clearTimeout(timer);
    } else if (onComplete) {
      onComplete();
    }
  }, [currentIndex, words, speed, onComplete, onPartialUpdate, displayedText]);

  return <>{displayedText}</>;
}; 